import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Venda } from '../models/venda';
import { CadastrarVendaDto } from '../dtos/CadastroVendaDto';

@Injectable({
  providedIn: 'root',
})
export class VendaService {
  private url = `${environment.apiUrl}/vendas`;

  constructor(private readonly http: HttpClient) {}

  cadastrar(venda: Venda): Observable<Venda> {
    // Recalcula totais a partir dos itens para evitar inconsistências
    if (typeof (venda as any).recalculateTotals === 'function') {
      (venda as any).recalculateTotals();
    }

    const request = {
      clienteId: venda.cliente?.id ?? null,
      usuarioId: venda.usuario?.id ?? null,
      vendedorId: venda.vendedor?.id ?? null,
      vendaSituacao: venda.vendaSituacao, // CORRIGIDO
      pagamento: venda.pagamento,
      observacao: venda.observacao || '',
      valorProdutos: Number(venda.subtotal) || 0,
      valorDesconto: Number(venda.desconto) || 0,
      valorAcrescimo: Number(venda.acrescimo) || 0,
      itens: venda.itens.map((item) => {
        const preco = Number(item.produto?.preco) || 0;
        const quantidade = Number(item.quantidade) || 0;
        return {
          produto: item.produto,
          preco: preco,
          valorProdutos: preco * quantidade, // base price * qty
          valorDesconto: Number(item.valorDesconto) || 0,
          valorAcrescimo: Number(item.valorAcrescimo) || 0,
          quantidade: quantidade,
        };
      }),
    } as CadastrarVendaDto;

    console.log('[VendaService] payload:', request);

    return this.http.post<Venda>(`${this.url}`, request);
  }

  // PDF da venda como Blob (backend expõe GET /exportar-pdf/{id}?tipo=A4|CUPOM)
  exportarPdf(id: number, tipo: string = 'A4'): Observable<Blob> {
    const params = new HttpParams().set('tipo', tipo);
    return this.http.get(`${this.url}/exportar-pdf/${id}`, { params, responseType: 'blob' });
  }

  selecionar(): Observable<Venda[]> {
    return this.http.get<Venda[]>(this.url);
  }

  selecionarPorData(dataInicial: string, dataFinal: string): Observable<Venda[]> {
    return this.http.get<Venda[]>(`${this.url}/por-data?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  cancelarVenda(id: number): Observable<Venda> {
    return this.http.patch<Venda>(`${this.url}/cancelar/${id}`, {});
  }

  listarVendasTop100(): Observable<Venda[]> {
    return this.http.get<Venda[]>(`${this.url}/top100`);
  }

  buscarPorId(id: number): Observable<Venda> {
    return this.http.get<Venda>(`${this.url}/${id}`);
  }

  buscaPedidoOuOrcamentoPorId(id: number): Observable<Venda> {
    return this.http.get<Venda>(`${this.url}/pedido-orcamento/${id}`);
  }

  alterar(id: number, venda: Venda): Observable<Venda> {
    // Garante que os ids dos itens sejam enviados, se existirem
    const request = {
      clienteId: venda.cliente?.id ?? null,
      usuarioId: venda.usuario?.id ?? null,
      vendedorId: venda.vendedor?.id ?? null,
      vendaSituacao: venda.vendaSituacao,
      pagamento: venda.pagamento,
      observacao: venda.observacao || '',
      valorProdutos: Number(venda.subtotal) || 0,
      valorDesconto: Number(venda.desconto) || 0,
      valorAcrescimo: Number(venda.acrescimo) || 0,
      itens: venda.itens.map((item) => ({
        id: (item as any).id, // Garante que o id do item seja enviado se existir
        produto: item.produto,
        preco: Number(item.produto?.preco) || 0,
        valorProdutos: Number(item.produto?.preco) * Number(item.quantidade) || 0,
        valorDesconto: Number(item.valorDesconto) || 0,
        valorAcrescimo: Number(item.valorAcrescimo) || 0,
        quantidade: Number(item.quantidade) || 0,
      })),
    };
    return this.http.put<Venda>(`${this.url}/${id}`, request);
  }
}
